import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth-service';

import { logger } from '@core/utils/logger';
export const HasTableSessionGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Obtenemos el valor actual del Signal
  const tableId = authService.tableSessionId();

  // 1. Si no hay ID, o es un string vacío/nulo, fuera.
  // Usamos una validación simple: si no es truthy, no es válido.
  if (!tableId || tableId === 'null' || tableId === 'undefined') {
    logger.warn('Navegación', 'Sin sesión de mesa: se redirige al inicio');
    return router.parseUrl('/');
  }

  // 2. Si llegamos acá, la sesión existe
  return true;
};
